import { IModelAction, MODEL_SET } from './types';
import { IModelState } from '../../../types/types';

export const modelSet = (
    model: IModelState
): IModelAction => {
    return {
        type: MODEL_SET,
        model,
    }
};
